import { gql } from "@apollo/client"

export const STORE_REGISTER = gql`
  mutation StoreRegister($input: StoreRegisterInput!) {
    StoreRegister(input: $input) {
      status {
        success
        name
        detail
      }
      store {
        id
        name
        description
        phone
        email
        urlLogo
        cover
        siteUrl
        facebookUrl
        instagramUrl
        youtubeUrl
        twitterUrl
      }
    }
  }
`
